import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getHomepage } from "../services/home.service";
// Async thunk to fetch homepage data
export const fetchHomeData = createAsyncThunk(
  "home/fetchHomeData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getHomepage();
      return response; // no .data.data here
    } catch (error) {
      console.error("fetchHomeData error:", error);
      return rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);
const homeSlice = createSlice({
  name: "home",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHomeData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHomeData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;

      })
      .addCase(fetchHomeData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        console.error("Home data fetch failed:", state.error);
      });
  },
});
export default homeSlice.reducer;
